import { render, staticRenderFns } from "./KZGReportSentEmailList.vue?vue&type=template&id=411b8372"
import script from "./KZGReportSentEmailList.vue?vue&type=script&lang=js"
export * from "./KZGReportSentEmailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports